import React, { useEffect, useState } from "react";
import images from "../../../images";
import { formatDate } from "../../../Utils/helper";
import { useTranslation } from "react-i18next";

const Counter = ({ value, onChange }) => {
  return (
    <div className="flex overflow-hidden gap-10 justify-between items-center px-2.5 py-2.5 w-full bg-white rounded-xl border border-solid border-stone-200 min-h-[42px]">
      {/* <button
        onClick={() => onChange(Math.max(0, value - 1))}
        className="flex overflow-hidden flex-col justify-center items-center self-stretch px-1.5 my-auto w-6 h-6 rounded-md bg-stone-200 min-h-6"
        disabled={value === 0}
      >
        <img
          onClick={() => onChange(value - 1)}
          src={images.MinusIcon}
          className="object-contain w-6 h-6"
          alt="Decrease"
        />
      </button> */}
      <span className="self-stretch my-auto mx-auto text-sm font-medium text-zinc-800">
        {value}
      </span>
      {/* <button
        // onClick={() => onChange(value + 1)}
        className="flex overflow-hidden gap-2.5 justify-center items-center self-stretch px-1.5 my-auto w-6 h-6 rounded-md bg-stone-200 min-h-6"
      >
        <img
          // onClick={() => onChange(value + 1)}
          src={images.SumIcon}
          className="object-contain self-stretch my-auto  aspect-square w-6 h-6 "
          alt="Increase"
        />
      </button> */}
    </div>
  );
};

export const StatsWidget = ({
  token,
  expiryTime,
  location,
  maxSlot,
  incentives,
}) => {
  const { t } = useTranslation();

  const [shopperCount, setShopperCount] = useState(0);

  useEffect(() => {
    if (typeof maxSlot === "number" && !isNaN(maxSlot)) {
      setShopperCount(Math.max(0, maxSlot));
    }
  }, [maxSlot]);

  return (
    <section className="flex flex-col mt-4 justify-center p-3 w-full bg-yellow-50 rounded-xl border border-solid border-stone-200">
      <div className="flex gap-3 w-full min-h-[72px]">
        <div className="flex flex-col flex-1 shrink justify-center items-center py-2.5 whitespace-nowrap bg-white rounded-xl basis-0">
          <h3 className="text-xs text-center text-zinc-800">
            {t("quest.statsWidget.incentive")}
          </h3>
          <div className="flex gap-0.5 items-center mt-5 text-sm font-medium text-indigo-600">
            {/* <img
              src={images.PointGetIcon}
              className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
              alt="Token icon"
            /> */}
            <span>${incentives}</span>
          </div>
        </div>
        <div className="flex flex-col min-w-[40%] shrink justify-center items-center py-2.5 bg-white rounded-xl basis-0">
          <h3 className="text-xs text-center text-zinc-800">
            {t("quest.statsWidget.expiryDate")}
          </h3>
          <div className="flex gap-0.5 items-center mt-5 text-sm font-medium text-indigo-600 ">
            <img
              src={images.ExpiryTimeIconYellow}
              className="object-contain shrink-0 self-stretch my-auto w-5 rounded-md aspect-square"
              alt="Calendar icon"
            />
            <time>{formatDate(expiryTime)}</time>
          </div>
        </div>
        <div className="flex flex-col flex-1 shrink justify-center items-center py-2.5 whitespace-nowrap bg-white rounded-xl basis-0">
          <h3 className="text-xs text-center text-zinc-800">
            {t("quest.statsWidget.locations")}
          </h3>
          <div className="flex gap-0.5 items-center mt-5 text-sm font-medium text-indigo-600">
            <img
              src={images.MapIconYellow}
              className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
              alt="Location icon"
            />
            <span>{location}</span>
          </div>
        </div>
      </div>
      <div className="mt-4 w-full">
        <h3 className="text-sm leading-none text-neutral-500 py-2">
          {t("quest.statsWidget.mysteryShoppers")}
        </h3>
        <Counter value={shopperCount ?? maxSlot} onChange={setShopperCount} />
      </div>
    </section>
  );
};
